/* eslint-disable object-shorthand */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.Cat = function (scene) {
  this.scene = scene;
  this.gameConfig = this.scene.gameConfig;
  this.catSprite = null;
  this.explosion = null;

  this.yUp = 0;
  this.yDown = 0;

  this.flyTime = 4000;
  this.flyToTargetTime = 2000;
  this.flyTween = null;

  this.isBusy = false;
};
/**
 *
 */
EDC.Animations.Cat.prototype.setAppearanceTarget = function (x, y) {
  this.appearanceX = x;
  this.appearanceY = y;
};
/**
 *
 */
EDC.Animations.Cat.prototype.create = function (yUp, yDown) {
  this.catSprite = this.scene.add.sprite(0, 0, 'cat');
  this.catSprite.setPosition(-this.catSprite.width, 0);

  this.explosion = this.scene.add.sprite(0, 0, 'explosion');
  this.explosion.setPosition(this.catSprite.x, this.catSprite.y);
  this.explosion.setAlpha(0);
  this.explosion.on(
    'animationcomplete',
    function () {
      this.explosion.setAlpha(0);
      this.isBusy = false;
      this.appear();
    },
    this,
  );

  this.yUp = yUp;
  this.yDown = yDown;
};
/**
 *
 */
EDC.Animations.Cat.prototype.appear = function () {
  if (this.flyTween && this.flyTween.isPlaying()) {
    this.flyTween.stop();
  }
  this.isBusy = true;
  this.catSprite.x = -this.catSprite.width;
  this.catSprite.y = this.appearanceY;
  this.catSprite.frame = 0;
  this.catSprite.play('catAppear');
  this.flyTween = this.scene.tweens.add({
    targets: this.catSprite,
    x: this.appearanceX,
    y: this.appearanceY,
    ease: 'Linear',
    duration: 1500,
    onComplete: this.flyCompleteCallback.bind(this),
  });
};
/**
 *
 */
EDC.Animations.Cat.prototype.flyCompleteCallback = function () {
  this.scene.allowInteract();
  this.catSprite.anims.stop();
  this.catSprite.setFrame(6);
  this.flyUp();
  this.isBusy = false;
};
/**
 *
 */
EDC.Animations.Cat.prototype.explode = function () {
  this.isBusy = true;
  if (this.flyTween.isPlaying()) {
    this.flyTween.stop();
  }

  this.explosion.setPosition(this.catSprite.x, this.catSprite.y);
  this.catSprite.x = -this.catSprite.width;
  this.explosion.setAlpha(1);
  this.explosion.play('catExplode');
};
/**
 *
 */
EDC.Animations.Cat.prototype.calculateTime = function (targetY, time) {
  const distance = Math.abs(targetY - this.catSprite.y);
  const fullHeight = this.yDown - this.yUp;
  const msPerPixel = time / fullHeight;
  return distance * msPerPixel;
};
/**
 *
 */
EDC.Animations.Cat.prototype.flyTo = function (x, y, completeCallback) {
  if (this.flyTween && this.flyTween.isPlaying()) {
    this.flyTween.stop();
  }
  if (y < this.catSprite.y) {
    this.catSprite.setFrame(5);
  } else {
    this.catSprite.setFrame(7);
  }
  const time = this.calculateTime(y, this.flyToTargetTime);
  this.flyTween = this.scene.tweens.add({
    targets: this.catSprite,
    y: y,
    duration: time,
    ease: 'Linear',
    onComplete: function () {
      if (completeCallback) {
        completeCallback();
      }
    },
  });
};
/**
 *
 */
EDC.Animations.Cat.prototype.flyUp = function () {
  this.catSprite.setFrame(5);
  const time = this.calculateTime(this.yUp, this.flyTime);
  this.flyTween = this.scene.tweens.add({
    targets: this.catSprite,
    y: this.yUp + this.catSprite.height / 2,
    duration: time,
    ease: 'Linear',
    onComplete: function () {
      this.flyDown();
    }.bind(this),
  });
};
/**
 *
 */
EDC.Animations.Cat.prototype.flyDown = function () {
  this.catSprite.setFrame(7);
  const time = this.calculateTime(this.yDown, this.flyTime);
  this.flyTween = this.scene.tweens.add({
    targets: this.catSprite,
    y: this.yDown - this.catSprite.height / 2,
    duration: time,
    ease: 'Linear',
    onComplete: function () {
      this.flyUp();
    }.bind(this),
  });
};
/**
 *
 */
EDC.Animations.Cat.prototype.getSize = function () {
  return {
    width: this.catSprite.width,
    height: this.catSprite.height,
  };
};

export default EDC.Animations.Cat;
